<template>
  <div :class="wrapperClass">
    <wui-modal
      :title="title"
      :size="40"
      :closable="closable"
    >
      <p
        v-if="message"
        class="text-body-r-14-20 text-fg-base-fg10"
      >
        {{ message }}
      </p>

      <template #footer>
        <wui-btn
          :size="40"
          variant="neut"
          state="alpha"
          data-test="close-false"
          @click="close(false)"
        >
          {{ cancelLabel || $t('common.no') }}
        </wui-btn>
        <wui-btn
          :size="40"
          variant="brand"
          :state="textActions ? 'alpha' : 'filled'"
          data-test="close-true"
          @click="close(true)"
        >
          <span>{{ confirmLabel || $t('common.yes') }}</span>
        </wui-btn>
      </template>
    </wui-modal>
  </div>
</template>

<script setup lang="ts">
import { closeDialogKey, safeInject, WuiBtn, WuiModal } from '@wui/common-library'
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  title: string
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  textActions?: boolean
  /** Кнопка-крестик в шапке. `false` — как в макете открепления всех. */
  closable?: boolean
  /** Ширина по контенту (hug), иначе стандартные 480px modal40. */
  fitContent?: boolean
}>(), {
  message: '',
  confirmLabel: '',
  cancelLabel: '',
  textActions: false,
  closable: true,
  fitContent: false,
})

const wrapperClass = computed(() => {
  if (!props.fitContent) {
    return undefined
  }
  // Figma unpin-all: 353×122, gap title→actions 20px
  return [
    'confirm-dialog--fit',
    !props.message ? 'confirm-dialog--title-only' : '',
  ]
})

const closeModal = safeInject(closeDialogKey)

const close = (value: boolean) => {
  closeModal(value)
}
</script>

<style scoped>
/*
  Класс на wrapper: scoped :deep не матчил self, когда class висел на корне WuiModal.
  Figma: hug ~353×122, gap 20 между title и кнопками.
*/
.confirm-dialog--fit :deep(.wui-modal) {
  --modal-gap: 20px;
  width: max-content !important;
  max-width: calc(100vw - 32px) !important;
}

.confirm-dialog--fit :deep(.wui-modal__title) {
  min-width: max-content;
  white-space: nowrap;
}

.confirm-dialog--title-only :deep(.wui-modal) {
  --modal-title-pad-y: 0px;
}

.confirm-dialog--title-only :deep(.wui-modal__content) {
  display: none;
}
</style>
